import React, { useCallback, useEffect, useMemo } from 'react';

import { useSelector } from 'react-redux';

import { AccordionPanel } from 'reaxl';

import getFilterTitle from '@/utilities/getFilterTitle';

import srpFiltersDuck from '@/ducks/srp/srpFiltersDuck.js';

import FilterCheckboxes from './FilterCheckboxes';
import FilterPlaceholder from './FilterPlaceholder';

function InteriorColorFilter({
    onOptionChange = () => { },
    onOptionsClear = () => { },
    handleShowExpansion = () => { },
}) {
    const interiorColorOptions = useSelector(srpFiltersDuck.selectors.getInteriorColorOptions);
    const interiorColorValues = useSelector(srpFiltersDuck.selectors.getInteriorColorValues);

    const filterName = 'intColorSimple';

    const isExpanded = useSelector(useCallback((state) => srpFiltersDuck.selectors.isExpansionActive(state, filterName), [filterName]));

    const showFilter = useMemo(
        () => isExpanded && Object.keys(interiorColorOptions).length !== 0,
        [isExpanded, interiorColorOptions]
    );

    const title = useMemo(
        () => getFilterTitle('Interior Color', interiorColorValues),
        [interiorColorValues]
    );

    const filterValues = useMemo(() => ({
        intColorSimple: interiorColorValues,
    }), [interiorColorValues]);

    const getFilterOptions = useCallback((formattedOptions) => formattedOptions?.map((option) => ({
        ...option,
        label: option.label,
        colorValue: option.value,
    })), []);

    const shouldExpand = useMemo(() => interiorColorValues.length > 0, [interiorColorValues.length]);

    // expand the panel if active options inside of it
    useEffect(() => {
        if (shouldExpand) {
            handleShowExpansion(filterName);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shouldExpand, filterName]);

    const filterCheckboxesProps = useMemo(() => ({
        className: 'visual-checkboxes',
        filter: interiorColorOptions,
        values: filterValues,
        customFilterOptions: getFilterOptions,
        onOptionChange,
        onOptionsClear,
        withAccordion: false,
    }), [interiorColorOptions, filterValues, getFilterOptions, onOptionChange, onOptionsClear]);

    return (
        <AccordionPanel
            contentPadding={5}
            eventKey={filterName}
            data-cmp="filterInteriorColors"
            title={title}
        >
            {!showFilter && <FilterPlaceholder uniqueKey={filterName} />}
            {showFilter && <FilterCheckboxes {...filterCheckboxesProps} />}
        </AccordionPanel>
    );
}

InteriorColorFilter.displayName = 'InteriorColorFilter';

export default React.memo(InteriorColorFilter);
